import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Hidden from '@mui/material/Hidden';
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import YouTube from 'react-youtube';
import './VideoPlayBackDialog.css';

class VideoPlayBackDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video_player_ref: undefined,
    }
  }

  handler = (data) => {
    this.setState(data);
  }

  onPlayerReady = (event) => {
    //var embedCode = event.target.getVideoEmbedCode();
    event.target.playVideo();
    //if (document.getElementById('embed-code')) {
    //  document.getElementById('embed-code').innerHTML = embedCode;
    //}
    this.setState({video_player_ref: event.target});
  }

  handleKeyPress = (event) => {
    //const key = event.key;

    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
  };

  handleCancelClick = () => {
    if (this.state.video_player_ref) {
      this.state.video_player_ref.pauseVideo();
    }
    this.props.onCancelClick();
  }

  handleOkClick = () => {
    this.state.video_player_ref.pauseVideo();
    this.props.onCancelClick();
    this.props.onOkClick();
  }

  render() {
    // Dialog Properties
    const { open } = this.props;

    // Custom Properties
    const { title, cancelText, okText, highlightOkButton } = this.props;

    // Dialog Events
    const { onClose } = this.props;

    // Custom Events
    const { onCancelClick, onOkClick } = this.props;

    if (!onClose) {
      return null;
    }
    
    const opts = {
      height: '100%',
      width: '100%',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        modestbranding: 1,
        playsinline: 0,
        enablejsapi: 1,
        rel: 0,
        origin: "https://captionly.co",
        host: "https://captionly.co",
        widget_referrer: "https://captionly.co/home",
      }
    };


    return (
      <Dialog fullScreen={true} 
      sx={theme => ({
        '& .MuiDialog-paper': { backgroundColor: theme.palette.grey[800]}
      })}
      open={open} onClose={onClose} onKeyPress={this.handleKeyPress} >

        {title &&
        <DialogTitle>
            {title}
            <Hidden only={['md', 'lg', 'xl']}>
              <Button sx={{ position: "fixed", top: "20px", right: '20px' }}
                onClick={this.handleCancelClick} variant="outlined" color="primary" size="small">X</Button>
            </Hidden>
        </DialogTitle>}


        <DialogContent dividers={true} sx={{margin: 0, padding: 0}}>
          <Box sx={{
              minWidth: "calc((100vh - 4rem) * 9 / 16)",
              maxWidth: "calc((100vh - 4rem) * 9 / 16)",
              margin: "auto",
            }}>
              <YouTube
                videoId="7U2pPmXLkfU"
                id="demo_video"
                className="youtube_video"
                iframeClassName="youtube_video_container"
                opts={opts}
                onReady={this.onPlayerReady}
              />
          </Box>
        </DialogContent>

        {(onCancelClick || onOkClick) &&
          <DialogActions>
            {onCancelClick &&
              <Button color="primary" fullWidth={true} onClick={this.handleCancelClick} variant="outlined">
                {cancelText || 'Cancel'}
              </Button>
            }

            {onOkClick &&
              <Button color="primary" fullWidth={true} onClick={this.handleOkClick} disabled={!this.state.video_player_ref} variant={highlightOkButton && 'contained'}>
                {okText || 'OK'}
              </Button>
            }
          </DialogActions>
        }
      </Dialog>
    );
  }
}

VideoPlayBackDialog.propTypes = {
  fullScreen: PropTypes.bool,
  open: PropTypes.bool.isRequired,

  title: PropTypes.string,
  contentText: PropTypes.string,
  textField: PropTypes.element,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  disableOkButton: PropTypes.bool,
  highlightOkButton: PropTypes.bool,

  onClose: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func,
  onOkClick: PropTypes.func
};

export default VideoPlayBackDialog;
